import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

export interface VatGroup {
	code: string;
	name: string;
	rate: number;
	definitionRate?: number;
	usageCount?: number;
}

export function useVatGroups() {
	const [vatGroups, setVatGroups] = useState<VatGroup[]>([]);

	useEffect(() => {
		void (async () => {
			try {
				const res = await api.get<VatGroup[]>(`/api/sap/vat-groups`);
				setVatGroups(res ?? []);
			} catch {
				setVatGroups([]);
			}
		})();
	}, []);

	const sorted = useMemo(
		() =>
			[...vatGroups].sort(
				(a, b) =>
					(b.usageCount ?? 0) - (a.usageCount ?? 0) || a.code.localeCompare(b.code, "tr"),
			),
		[vatGroups],
	);

	const options = useMemo(
		() =>
			sorted.map((v) => ({
				value: v.code,
				label: `${v.code} — %${v.rate}${v.name ? ` · ${v.name}` : ""}`,
			})),
		[sorted],
	);

	return { vatGroups: sorted, options };
}
